// extracted by mini-css-extract-plugin
export default {"root":"HeaderSection_root__iMPtD","title":"HeaderSection_title__MA+1U","description":"HeaderSection_description__hDSRk"};